/*json-schema-for-turbojson*/
/*sourcing-from-the-web*/
/*sourcing-from-nodemodules*/
/*linting-for-environment-variables*/
/*turborepo-lsp*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "编辑器集成",
  "description": "充分利用 Turborepo"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "为了获得最佳的 turbo 体验，Turborepo 提供了一些实用程序，可与你的编辑器集成。"
  }, {
    "heading": "",
    "content": "¥To get the best experience with turbo, Turborepo provides a few utilities for integrating with your editor."
  }, {
    "heading": "turbojson-的-json-schema-json-schema-for-turbojson",
    "content": "¥JSON Schema for turbo.json"
  }, {
    "heading": "turbojson-的-json-schema-json-schema-for-turbojson",
    "content": "Turborepo 使用 JSON Schema 为你的 turbo.json 文件提供自动补齐功能。通过在 turbo.json 中包含 $schema 键，你的编辑器能够在出现无效形状或缺少键的情况下提供完整的文档和代码检查。"
  }, {
    "heading": "turbojson-的-json-schema-json-schema-for-turbojson",
    "content": "¥Turborepo uses JSON Schema to give you auto-complete in your\nturbo.json file. By including the $schema key in your turbo.json, your editor is able to\nprovide full documentation and linting in case you have invalid shapes or missing keys."
  }, {
    "heading": "从网络采购-sourcing-from-the-web",
    "content": "¥Sourcing from the web"
  }, {
    "heading": "从网络采购-sourcing-from-the-web",
    "content": "可以通过以下 URL 访问 schema.json。这样做的好处是无需运行包管理器的安装命令即可查看编辑器内的验证。"
  }, {
    "heading": "从网络采购-sourcing-from-the-web",
    "content": "¥A schema.json is accessible at the URL shown below. This has the advantage of not needing to run your package manager's install command to see in-editor validation."
  }, {
    "heading": "从网络采购-sourcing-from-the-web",
    "content": "还有一个主要版本的 schema.json 可用，遵循 https://turbo.nodejs.cn/schema.<version>.json 的格式。"
  }, {
    "heading": "从网络采购-sourcing-from-the-web",
    "content": "¥There is also a major versioned schema.json available, following the format of https://turbo.nodejs.cn/schema.<version>.json."
  }, {
    "heading": "从-node_modules-采购-sourcing-from-nodemodules",
    "content": "¥Sourcing from node_modules"
  }, {
    "heading": "从-node_modules-采购-sourcing-from-nodemodules",
    "content": "从 Turborepo 2.4 开始，运行包管理器的安装命令后，schema.json 即可在 node_modules 中使用："
  }, {
    "heading": "从-node_modules-采购-sourcing-from-nodemodules",
    "content": "¥Starting in Turborepo 2.4, schema.json is available in node_modules once you've run your package manager's install command:"
  }, {
    "heading": "从-node_modules-采购-sourcing-from-nodemodules",
    "content": "我们建议将 turbo 安装在你的代码库的根目录下，这样 schema 的路径应该指向你代码库根目录下的 node_modules。在 软件包配置 中，你可能需要使用类似 ../../node_modules/turbo/schema.json 的路径。"
  }, {
    "heading": "从-node_modules-采购-sourcing-from-nodemodules",
    "content": "¥We recommend installing turbo at the root of your repository, so the path\nfor the schema should point to node_modules at the root of your repository.\nIn Package Configurations, you may\nneed to use a path like ../../node_modules/turbo/schema.json."
  }, {
    "heading": "环境变量的-linting-linting-for-environment-variables",
    "content": "¥Linting for environment variables"
  }, {
    "heading": "环境变量的-linting-linting-for-environment-variables",
    "content": "处理环境变量是 Turborepo 中构建应用的重要组成部分。"
  }, {
    "heading": "环境变量的-linting-linting-for-environment-variables",
    "content": "¥Handling environment variables is an important part of building applications in a Turborepo."
  }, {
    "heading": "环境变量的-linting-linting-for-environment-variables",
    "content": "eslint-config-turbo 软件包 扩展了你的 ESLint 设置，以帮助你确保已处理所有环境变量。"
  }, {
    "heading": "环境变量的-linting-linting-for-environment-variables",
    "content": "¥The eslint-config-turbo package extends your ESLint setup to help you make sure you've taken care of all of your environment variables."
  }, {
    "heading": "turborepo-lsp-turborepo-lsp",
    "content": "比 JSON Schema 提供的自动补齐和 linting 功能更强大，编辑器内提供无效 glob 的提示、对不存在的任务或包的引用，以及额外的仓库可见性工具。"
  }, {
    "heading": "turborepo-lsp-turborepo-lsp",
    "content": "¥Enable even more auto-complete and linting than provided by JSON Schema, with in-editor hinting for invalid globs, references to non-existent tasks or packages, and\nextra repository visibility tools."
  }, {
    "heading": "turborepo-lsp-turborepo-lsp",
    "content": "访问 VSCode 扩展市场 进行安装。"
  }, {
    "heading": "turborepo-lsp-turborepo-lsp",
    "content": "¥Visit the VSCode Extension Marketplace to install."
  }, {
    "heading": "turborepo-lsp-turborepo-lsp",
    "content": "语言服务器可用于任何支持 语言服务器协议 的编辑器。在我们的 问题跟踪器 中记录请求以表达你的兴趣。"
  }, {
    "heading": "turborepo-lsp-turborepo-lsp",
    "content": "¥The language server can be used on any editors that support the Language\nServer Protocol. Log a\nrequest in our issue tracker to\nexpress your interest."
  }],
  "headings": [{
    "id": "turbojson-的-json-schema-json-schema-for-turbojson",
    "content": "turbo.json 的 JSON Schema /*json-schema-for-turbojson*/"
  }, {
    "id": "从网络采购-sourcing-from-the-web",
    "content": "从网络采购 /*sourcing-from-the-web*/"
  }, {
    "id": "从-node_modules-采购-sourcing-from-nodemodules",
    "content": "从 node_modules 采购 /*sourcing-from-nodemodules*/"
  }, {
    "id": "环境变量的-linting-linting-for-environment-variables",
    "content": "环境变量的 Linting /*linting-for-environment-variables*/"
  }, {
    "id": "turborepo-lsp-turborepo-lsp",
    "content": "Turborepo LSP /*turborepo-lsp*/"
  }]
};
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#turbojson-的-json-schema-json-schema-for-turbojson",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "turbo.json"
    }), " 的 JSON Schema "]
  })
}, {
  depth: 3,
  url: "#从网络采购-sourcing-from-the-web",
  title: _jsx(_Fragment, {
    children: "从网络采购 "
  })
}, {
  depth: 3,
  url: "#从-node_modules-采购-sourcing-from-nodemodules",
  title: _jsxs(_Fragment, {
    children: ["从 ", _jsx("code", {
      children: "node_modules"
    }), " 采购 "]
  })
}, {
  depth: 2,
  url: "#环境变量的-linting-linting-for-environment-variables",
  title: _jsx(_Fragment, {
    children: "环境变量的 Linting "
  })
}, {
  depth: 2,
  url: "#turborepo-lsp-turborepo-lsp",
  title: _jsx(_Fragment, {
    children: "Turborepo LSP "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["为了获得最佳的 ", _jsx(_components.code, {
        children: "turbo"
      }), " 体验，Turborepo 提供了一些实用程序，可与你的编辑器集成。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To get the best experience with ", _jsx(_components.code, {
        children: "turbo"
      }), ", Turborepo provides a few utilities for integrating with your editor."]
    }), "\n", _jsxs(_components.h2, {
      id: "turbojson-的-json-schema-json-schema-for-turbojson",
      children: [_jsx(_components.code, {
        children: "turbo.json"
      }), " 的 JSON Schema "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥JSON Schema for ", _jsx(_components.code, {
        children: "turbo.json"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 使用 ", _jsx(_components.a, {
        href: "https://json-schema.org/",
        children: "JSON Schema"
      }), " 为你的 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 文件提供自动补齐功能。通过在 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中包含 ", _jsx(_components.code, {
        children: "$schema"
      }), " 键，你的编辑器能够在出现无效形状或缺少键的情况下提供完整的文档和代码检查。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Turborepo uses ", _jsx(_components.a, {
        href: "https://json-schema.org/",
        children: "JSON Schema"
      }), " to give you auto-complete in your\n", _jsx(_components.code, {
        children: "turbo.json"
      }), " file. By including the ", _jsx(_components.code, {
        children: "$schema"
      }), " key in your ", _jsx(_components.code, {
        children: "turbo.json"
      }), ", your editor is able to\nprovide full documentation and linting in case you have invalid shapes or missing keys."]
    }), "\n", _jsx(_components.h3, {
      id: "从网络采购-sourcing-from-the-web",
      children: "从网络采购 "
    }), "\n", _jsx(_components.p, {
      children: "¥Sourcing from the web"
    }), "\n", _jsxs(_components.p, {
      children: ["可以通过以下 URL 访问 ", _jsx(_components.code, {
        children: "schema.json"
      }), "。这样做的好处是无需运行包管理器的安装命令即可查看编辑器内的验证。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥A ", _jsx(_components.code, {
        children: "schema.json"
      }), " is accessible at the URL shown below. This has the advantage of not needing to run your package manager's install command to see in-editor validation."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"https://turbo.nodejs.cn/schema.json\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["还有一个主要版本的 ", _jsx(_components.code, {
        children: "schema.json"
      }), " 可用，遵循 ", _jsx(_components.code, {
        children: "https://turbo.nodejs.cn/schema.<version>.json"
      }), " 的格式。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥There is also a major versioned ", _jsx(_components.code, {
        children: "schema.json"
      }), " available, following the format of ", _jsx(_components.code, {
        children: "https://turbo.nodejs.cn/schema.<version>.json"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"https://turbo.nodejs.cn/schema.v1.json\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "从-node_modules-采购-sourcing-from-nodemodules",
      children: ["从 ", _jsx(_components.code, {
        children: "node_modules"
      }), " 采购 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Sourcing from ", _jsx(_components.code, {
        children: "node_modules"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["从 Turborepo 2.4 开始，运行包管理器的安装命令后，", _jsx(_components.code, {
        children: "schema.json"
      }), " 即可在 ", _jsx(_components.code, {
        children: "node_modules"
      }), " 中使用："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Starting in Turborepo 2.4, ", _jsx(_components.code, {
        children: "schema.json"
      }), " is available in ", _jsx(_components.code, {
        children: "node_modules"
      }), " once you've run your package manager's install command:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./node_modules/turbo/schema.json\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(Callout, {
      title: "node_modules location",
      children: [_jsxs(_components.p, {
        children: ["我们建议将 ", _jsx(_components.code, {
          children: "turbo"
        }), " 安装在你的代码库的根目录下，这样 schema 的路径应该指向你代码库根目录下的 ", _jsx(_components.code, {
          children: "node_modules"
        }), "。在 ", _jsx(_components.a, {
          href: "/docs/reference/package-configurations",
          children: "软件包配置"
        }), " 中，你可能需要使用类似 ", _jsx(_components.code, {
          children: "../../node_modules/turbo/schema.json"
        }), " 的路径。"]
      }), _jsxs(_components.p, {
        children: ["¥We recommend installing ", _jsx(_components.code, {
          children: "turbo"
        }), " at the root of your repository, so the path\nfor the schema should point to ", _jsx(_components.code, {
          children: "node_modules"
        }), " at the root of your repository.\nIn ", _jsx(_components.a, {
          href: "/docs/reference/package-configurations",
          children: "Package Configurations"
        }), ", you may\nneed to use a path like ", _jsx(_components.code, {
          children: "../../node_modules/turbo/schema.json"
        }), "."]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "环境变量的-linting-linting-for-environment-variables",
      children: "环境变量的 Linting "
    }), "\n", _jsx(_components.p, {
      children: "¥Linting for environment variables"
    }), "\n", _jsx(_components.p, {
      children: "处理环境变量是 Turborepo 中构建应用的重要组成部分。"
    }), "\n", _jsx(_components.p, {
      children: "¥Handling environment variables is an important part of building applications in a Turborepo."
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "/docs/reference/eslint-config-turbo",
        children: [_jsx(_components.code, {
          children: "eslint-config-turbo"
        }), " 软件包"]
      }), " 扩展了你的 ESLint 设置，以帮助你确保已处理所有环境变量。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsxs(_components.a, {
        href: "/docs/reference/eslint-config-turbo",
        children: ["The ", _jsx(_components.code, {
          children: "eslint-config-turbo"
        }), " package"]
      }), " extends your ESLint setup to help you make sure you've taken care of all of your environment variables."]
    }), "\n", _jsx(_components.h2, {
      id: "turborepo-lsp-turborepo-lsp",
      children: "Turborepo LSP "
    }), "\n", _jsx(_components.p, {
      children: "比 JSON Schema 提供的自动补齐和 linting 功能更强大，编辑器内提供无效 glob 的提示、对不存在的任务或包的引用，以及额外的仓库可见性工具。"
    }), "\n", _jsx(_components.p, {
      children: "¥Enable even more auto-complete and linting than provided by JSON Schema, with in-editor hinting for invalid globs, references to non-existent tasks or packages, and\nextra repository visibility tools."
    }), "\n", _jsxs(_components.p, {
      children: ["访问 ", _jsx(_components.a, {
        href: "https://marketplace.visualstudio.com/items?itemName=Vercel.turbo-vsc",
        children: "VSCode 扩展市场"
      }), " 进行安装。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Visit the ", _jsx(_components.a, {
        href: "https://marketplace.visualstudio.com/items?itemName=Vercel.turbo-vsc",
        children: "VSCode Extension Marketplace"
      }), " to install."]
    }), "\n", _jsxs(Callout, {
      type: "info",
      title: "Not using Visual Studio Code?",
      children: [_jsxs(_components.p, {
        children: ["语言服务器可用于任何支持 ", _jsx(_components.a, {
          href: "https://microsoft.github.io/language-server-protocol/",
          children: "语言服务器协议"
        }), " 的编辑器。在我们的 ", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/issues",
          children: "问题跟踪器"
        }), " 中记录请求以表达你的兴趣。"]
      }), _jsxs(_components.p, {
        children: ["¥The language server can be used on any editors that support the ", _jsx(_components.a, {
          href: "https://microsoft.github.io/language-server-protocol/",
          children: "Language\nServer Protocol"
        }), ". Log a\nrequest in our ", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/issues",
          children: "issue tracker"
        }), " to\nexpress your interest."]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
